<template>
<div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <div class="col-xs-12">


        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBanner===0">
                          <button type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBanner">
                          <button  type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBanner()"><i class="fa fa-dashboard fa-1x push-5-r"></i>  {{mainService.reference_name}}</h2>
            </div>

            <div v-if="flagDisplayBanner" class="block-content">

              <div class="row">
                <div class="col-xs-12">

                    <!-- Main Service Detail Information  -->
                    <div v-if="flagDisplayDetail===0" class="block">

                        <button  type="button" @click="toggleConfigView()" class="btn btn-dafault align-right" name="buttonAddPlanItem">
                          <i class="fa fa-gear fa-1x push-5-r "></i>{{ labelButtonConfig[actualLanguage] }}</button>

                        <div v-if="displayTab" class="col-xs-12">
                          <div class="block">
                            <ul class="nav nav-tabs nav-tabs-alt nav-justified" data-toggle="tabs">

                              <li :class="{'active': tabMenuSelector[0]==true}"  @click="toggleTabMenuSelector(0)">
                                  <a ><i class="fa fa-bar-chart-o"></i> {{tabLabelMenuVisualisation[actualLanguage] }}</a>
                              </li>

                              <li :class="{'active': tabMenuSelector[1]==true}"  @click="toggleTabMenuSelector(1)">
                                  <a ><i class="fa fa-pencil-square-o"></i> {{tabLabelMenuInvoices[actualLanguage] }}</a>
                              </li>

                              <li :class="{'active': tabMenuSelector[2]==true}"  @click="toggleTabMenuSelector(2)">
                                  <a ><i class="fa fa-dashboard"></i> {{tabLabelMenuSubService[actualLanguage] }}</a>
                              </li>
                            </ul>

                            <div class="block-content tab-content">

                              <div :class="{'tab-pane': true, 'active': tabMenuSelector[0]==true}" >
                                <div class="col-xs-12">
                                  <main-service-display-tab-graphs :mainService="mainService" ></main-service-display-tab-graphs>
                                </div>
                              </div>


                              <div :class="{'tab-pane': true, 'active': tabMenuSelector[1]==true}" >
                                <div class="col-xs-12">
                                  <main-service-display-tab-invoices :mainService="mainService" ></main-service-display-tab-invoices>
                                </div>
                              </div>



                              <div :class="{'tab-pane': true, 'active': tabMenuSelector[2]==true}" >
                                <div class="col-xs-12">

                                  <h2 class="block-title push">Liste des sous services</h2>
                                  <spinner  v-if="subServiceListIsLoading"></spinner>
                                  <div v-else>
                                      <div v-for="(subService,index) in subServiceList">
                                        <div class="row">
                                          <sub-service-display :subService="subService" ></sub-service-display>
                                          <div class="col-sm-12">
                                            <button  type="button" @click="deleteSubService(index)" class="btn btn-xs align-right" name="buttonAddPlanItem">
                                            <spinner size="small" v-if="serviceIsDeleting"></spinner>
                                            <span v-else><i class="fa fa-trash-o fa-1x push-5-r "></i>{{ labelButtonDeleteService[actualLanguage] }}</span></button>
                                          </div> 
                                        </div>
                                      </div>









                                      
                                  </div>

                                  <p><button @click="addSubService" type="button" class="btn  btn-success align-left" name="button"><i class="fa fa-plus fa-1x push-5-r "></i>{{ labelButtonAddSubService[actualLanguage] }}</button></p>

                                </div>


                              </div>
                            </div>
                          </div>
                        </div>
                  </div>





                    <!-- Main Service Detail Information  -->
                    <div v-else class="block">                      

                         <button  type="button" @click="toggleConfigView()" class="btn btn-default align-right" name="buttonAddPlanItem">
                          <i class="fa fa-close fa-1x push-5-r "></i>{{ labelButtonConfigClose[actualLanguage] }}</button>  

                        <h1 class="block-title push">Configuration service ID: {{ mainService.service_id}}</h1>

                        <div class="col-xs-12 col-md-12 push">
                          <div class="col-xs-12 col-sm-6">
                              <h6>{{labelRefenrenceName[actualLanguage]}}</h6>
                          </div>
                          <div class="col-xs-12 col-sm-6">
                                <input v-model="mainService.reference_name" class="form-control align-center" type="test"  placeholder="">
                          </div>
                        </div>


                        <div class="col-xs-12 col-md-12 push">
                              <div class="form-group">
                                <label class="col-xs-6" for="example-select">{{ selectLabelLinkedChannel[actualLanguage] }}</label>
                                <div class="col-sm-6">
                                    <select class="form-control" v-model=mainService.linked_channel_id size="1">
                                        <option value="Aucun/None">Aucun/None</option>
                                        <option v-for="channel in actualBundle.channels" :value="channel.ChannelData.channelId">{{channel.ReferenceName}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>




                        <h1 class="block-title push">Options</h1>
                        <div class="col-xs-12 col-md-12">

                            <div v-for="(category,index) in mainService.options" class="col-xs-12 col-md-12 push">
                              <h5  class=""><u>{{category.categoryTitle[actualLanguage]}}</u></h5>
                              <p class="push-30">{{category.categoryDescription[actualLanguage]}}</p>
                              

                              <div v-for="(Option,index2) in category.options" class="col-xs-12 col-md-12">

                                <div v-if="Option.valueType=='bool'" class="col-xs-12 col-md-12 push">

                                  <div class="col-xs-12 col-sm-9">
                                      <h6>{{Option.optionLabel[actualLanguage]}}</h6>
                                  </div>
                                  
                                  <div class="col-xs-12 col-sm-3">
                                      <label class="css-input switch switch-success">
                                      <input type="checkbox" checked v-model="Option.value">
                                      <span></span> <p v-if="Option.value">{{labelActivated[actualLanguage]}}</p>
                                      </label>
                                  </div>

                                </div>



                                <div v-if="Option.valueType=='stringNumber'" class="col-xs-12 col-md-12 push">
                                  <div class="col-xs-12 col-sm-9">
                                      <h6>{{Option.optionLabel[actualLanguage]}}</h6>
                                  </div>
                                  <div class="col-xs-12 col-sm-3">
                                        <input v-model="Option.value" class="form-control align-center" type="test"  placeholder="">
                                  </div>
                                </div>


                                <div v-if="Option.valueType=='listString'" class="col-xs-12 col-md-12">
                                  {{Option}}
                                </div>

                              </div>

                            </div>


                        </div>

                         <button  type="button" @click="saveMainServiceModifications()" class="btn btn-xs align-right" name="buttonAddPlanItem">
                          <spinner size="small" v-if="serviceIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelButtonSaveModifications[actualLanguage] }}</span></button> 

                    </div>

                    <!-- END Static Labels -->
                    </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'
import SubServiceDisplay from './SubServiceDisplay'
import MainServiceDisplayTabInvoices from './MainServiceDisplayTabInvoices'
import MainServiceDisplayTabGraphs from './MainServiceDisplayTabGraphs'

import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import moment from 'moment';

export default {
  name: 'GroupIndex',
  props: ['mainService'],

  data() {
    return {
      flagDisplayBanner : 0,
      flagDisplayDetail : 0,
      profileIsSaving : false,
      serviceIsDeleting:false,
      actualLanguage : "FR",
      tabMenuSelector : [],
      test : 0,
      displayTab : false,

      tabLabelMenuVisualisation : {FR: 'Visualisation', EN: 'Visualization'},
      tabLabelMenuInvoices : {FR: 'Saisie de factures', EN: 'Invoice entry'},
      tabLabelMenuSubService : {FR: 'Sous services', EN: 'Sub service'},

      labelTitleSection: {FR: 'Titre bannière', EN: 'Banner Title'},
      labelTitleBanner: {FR: 'Titre bannière', EN: 'Banner Title'},

      labelButtonConfig: {FR: 'Configuration', EN: 'Configuration'},
      labelButtonConfigClose: {FR: 'Fermer configuration', EN: 'Close configuration'},
      labelButtonSaveModifications: {FR: 'Enregistrer modifications', EN: 'Save modifications'},
      labelButtonDeleteService: {FR: "Supprimer", EN: 'Delete'},

      labelRefenrenceName: {FR: "Nom de référence du service", EN: 'Service reference name'},
      selectLabelLinkedChannel : {FR: "Appareil mesuré lié", EN: 'Linked monitored device'},

      tableOptionsColumnTitle01: {FR: "Description de l'option", EN: "Option description"},
      tableOptionsColumnTitle02: {FR: "Détail de l'option", EN: "Option detail"},
      labelActivated: {FR: "Activé", EN: 'Activated'},

      serviceIsSaving : false,
      subServiceListIsLoading : false,

      messageRemoveService:{FR: "ATTENTION : La supression d'un service peut affecter les configurations de votre système de répartition de coût, assurez vous que les unités lié au service principal et sous services rattachés n'y soient plus liés.",
                              EN: 'WARNING : The deletion of a  service can affect the configurations of your cost splitting system, make sure that the units linked to the main service and under attached services are no longer linked to it.'},
      messageRemoveConfirmA:{FR: "Confirmer la supression du service : ", EN: 'Confirm service deletion : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},


      subServiceList: [],
      labelButtonAddSubService: {FR: "Ajouter un sous service", EN: 'Add sub service'},

      messagePromptSubServiceReferenceName:{FR: "Nom de référence du sous service", EN: 'Sub service reference name'},
      messagePromptSubServiceReferenceNameTextBox:{FR: "Nom de référence", EN: 'Reference name'},

    }
  },
  components: {
    Spinner,
    SubServiceDisplay,
    MainServiceDisplayTabInvoices,
    MainServiceDisplayTabGraphs,
    DatePicker,
    TimePicker,
    TimeSelect
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','planTransactionData','actualBundle','parentContainer']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.flagDisplayBanner = ~this.flagDisplayBanner
      if(this.flagDisplayBanner==-1){this.readSubServiceList()}
    },

    toggleConfigView(){
      this.flagDisplayDetail = ~this.flagDisplayDetail
    },

    toggleTabMenuSelector(index){
        this.displayTab = false
        for(var n=0;n<this.tabMenuSelector.length;n++){this.tabMenuSelector[n]=false}
        this.tabMenuSelector[index]=true

        if(this.tabMenuSelector[2]){this.readSubServiceList()}

        //Comprend pas mais besoin de cette ligne pour que ca fonctionne !!
        this.test = index
        this.displayTab = true
    },

    saveMainServiceModifications(){
        var requestData = {'postAction':'SaveMainService',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'mainServiceData':this.mainService}
        this.serviceIsSaving=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              console.log(response)
            if(response.data.Code=='OK'){
                this.serviceIsSaving=false
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },

    readSubServiceList(){

        var requestData = {'postAction':'GetMainServicesSubService',
                          'bundleId':this.actualBundle.bundle_id,
                          'parentContainer':this.parentContainer,
                          'mainServiceId':this.mainService.service_id}
        this.subServiceListIsLoading=true
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response)
            if(response.data.Code=='OK'){
                this.subServiceListIsLoading=false
                this.subServiceList = response.data.SubServiceList
                //console.log(this.MainServiceList)
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.subServiceListIsLoading=false
                  }
            })

    },


    addSubService(){
        var subServiceReferenceName = prompt(this.messagePromptSubServiceReferenceName[this.actualLanguage], this.messagePromptSubServiceReferenceNameTextBox[this.actualLanguage]);

        if(subServiceReferenceName != null){
          var requestData = {'postAction':'AddMainServicesSubService',
                            'bundleId':this.actualBundle.bundle_id,
                            'parentContainer':this.parentContainer,
                            'mainServiceId':this.mainService.service_id,
                            'referenceName':subServiceReferenceName}
          this.$store.dispatch('sessionStore/postBundle', requestData)
              .then((response) => {
              if(response.data.Code=='OK'){
                  this.readSubServiceList()
                  }
                  else{
                    window.alert(response.data.PromptMessage[this.actualLanguage])
                    }
              })
        }
    },









    deleteSubService(index){
          window.alert(this.messageRemoveService[this.actualLanguage])
          var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.subServiceList[index].reference_name, this.messageRemoveConfirmB[this.actualLanguage]);

          if(confirmation=='DELETE'){
              this.deviceIsDeleting = true
              var requestData = { 'postAction':'DeleteSubService',
                                  'bundleId': this.actualBundle.bundle_id,
                                  'parentContainer':this.parentContainer,
                                  'mainServiceId':this.mainService.service_id,
                                  'subServiceId':this.subServiceList[index].sub_service_id
                                  }

              this.$store.dispatch('sessionStore/postBundle', requestData)
                  .then((response) => {
                    //console.log(response.data)
                  if(response.data.Code=='OK'){
                      //this.$store.dispatch('sessionStore/getGroupArborescence')
                      this.readSubServiceList()
                      }
                      else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                  })       
          }
    },


    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },



    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()
    this.toggleTabMenuSelector(0)

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// MainServiceDisplay.vue?1beb1d78